module.exports = __webpack_public_path__ + "media/images/pc/brands/tvb/_main-visual-text-2cf47d98b670d5e3cff878675b1516cb.svg";